import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './env.service';

@Injectable({
    providedIn: 'root'
})
export class GetContentManagementDataService {

    constructor(private http: HttpClient, private env: EnvService) { }

    getCurrentContentData(data): Observable<any> {
        return this.http.get<any>(this.env.siteApiUrl + 'web/getCurrentContent', {
            params: data
        });
    }
    getPreviewContentData(data): Observable<any> {
        return this.http.get<any>(this.env.siteApiUrl + 'web/getPreviewContent', {
            params: data
        });
    }
}